import { Create, Delete } from "@mui/icons-material"
import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import { getDiaHibrido } from "../../../../../../Utils/Utils"

const CardHorario = ({ horario, setIdToEdit, index, setOpenHorario, deleteHorario }) => {
    const { dia, ini, fim } = horario

    const editAutomacao = () => {
        setIdToEdit(index)
        setOpenHorario(true)
    }

    return (
        <Grid
            xs={12}
            sx={{ alignItems: 'center', paddingTop: '5px' }}
            container
        >
            <Grid container xs sx={{ border: '1px solid grey', padding: '10px', borderRadius: '5px', alignItems: 'center' }}>
                <Grid md={4}>
                    <Grid container xs={7} sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={1.5}>
                            <Typography fontSize="13px" fontWeight='400' >Dia: </Typography>
                        </Grid>
                        <Grid xs={12} md={10}>
                            <OneInput
                                defaultValue={getDiaHibrido(dia)}
                                readOnly
                                name={"descricao"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={3.5}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={3}>
                            <Typography fontSize="13px" fontWeight='400' >Inicial: </Typography>
                        </Grid>
                        <Grid xs={12} md={8}>
                            <OneInput
                                defaultValue={ini}
                                readOnly
                                name={"ini"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={3.5}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={3}>
                            <Typography fontSize="13px" fontWeight='400' >Fim: </Typography>
                        </Grid>
                        <Grid xs={12} md={8}>
                            <OneInput
                                defaultValue={fim}
                                readOnly
                                name={"fim"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md>
                    <Grid xs={1} container sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                        <Create titleAccess="Editar horario" sx={{ cursor: 'pointer', fontSize: '18px' }} onClick={() => { editAutomacao() }}/>
                        <Delete titleAccess="Deletar horario" sx={{ cursor: 'pointer', fontSize: '18px', color: '#a50b0b' }} onClick={() => deleteHorario(index)} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardHorario
